<template>
  <div
    v-if="isLaunched"
    class="single-column">
    <section
      v-show="!isLoggedIn"
      class="single-column__section">
      <h2 class="single-column__heading">ログイン</h2>
      <div class="login-block">
        <form
          :class="{ 'form--error': errorMessage.length > 0 }"
          @submit.prevent="submitForm">
          <div class="form-wrap">
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="username">
                  メールアドレス
                </label>
              </div>
              <div class="form-item">
                <input
                  id="username"
                  v-model="username"
                  class="form-control"
                  :disabled="isFormDisabled"
                  type="email"
                  name="username"
                  placeholder="例）sample@example.com"
                  @keypress.enter="$refs.password.focus()">
                <p
                  v-if="errorMessage"
                  class="error-text">
                  {{ errorMessage }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="password">
                  パスワード（8文字以上）
                </label>
              </div>
              <div class="form-item">
                <input
                  id="password"
                  ref="password"
                  v-model="password"
                  class="form-control"
                  :disabled="isFormDisabled"
                  type="password"
                  name="Password"
                  value=""
                  placeholder="半角英数のみ、8文字以上"
                  @keypress.enter="submitForm">
              </div>
            </div>
          </div>
          <div class="form-btn-area">
            <button
              class="c-btn"
              name="submit"
              type="button"
              :disabled="isButtonDisabled"
              @click.prevent="submitForm">
              ログイン<span class="c-btn__icon-arrow" />
            </button>
          </div>
          <div class="form-foot-linkarea">
            <a
              v-if="isBtoC && !nmId && googleFormUrl"
              :href="googleFormUrl"
              target="_blank"
              class="c-text-link">
              アカウント登録（無料）
            </a>
            <router-link
              v-if="isBtoC && !nmId && !googleFormUrl"
              :to="{ name: 'sign-up' }"
              class="c-text-link">
              アカウント登録（無料）
            </router-link>
            <router-link
              v-if="isBtoC && nmId"
              :to="{ name: 'sign-up-narasumate' }"
              class="c-text-link">
              アカウント登録（無料）
            </router-link>
            <router-link
              :to="{ name: 'password-reset' }"
              class="c-text-link c-text-link--black">
              パスワードを忘れた方はこちら
            </router-link>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoginDialog',

  data() {
    return {
      isLoading: false,
      isSuccess: false,
      username: '',
      password: '',
      errorMessage: '',
      nmId: '',
      googleFormUrl: null,
    }
  },

  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    isFieldsEmpty() {
      return this.username === '' || this.password === ''
    },

    isFormDisabled() {
      return this.isSuccess || this.isLoading
    },

    isButtonDisabled() {
      return this.isFieldsEmpty || this.isFormDisabled
    },
  },
  async mounted() {
    this.nmId = window.sessionStorage.getItem('narasu_mate_id')
    if (this.isBtoC) {
      const { data } = await window.axios.get('/api/client/registration/config')
      this.googleFormUrl = data.google_form_url || null
    }
  },
  methods: {
    async submitForm() {
      const { username, password } = this
      const credentials = { username, password }

      this.errorMessage = ''
      this.isLoading = true

      try {
        await this.$store.dispatch(
          'auth/login',
          { credentials, provider: 'clients' },
        )

        this.isLoading = false
        this.isSuccess = true

        // トップ画面に遷移
        setTimeout(this.transitionToTopPage, 1000)
      } catch (err) {
        this.isLoading = false

        if (err.response.status === 401) {
          this.errorMessage = 'ログインに失敗しました。もう一度お試しください。'
          this.password = ''
        }
      }
    },

    transitionToTopPage() {
      window.location.href = '/client/'
    },
  },
}
</script>
